export default "__VITE_ASSET___h7wdDV0__"